import { render, staticRenderFns } from "./columnsMappingBase.vue?vue&type=template&id=607b9410&"
import script from "./columnsMappingBase.vue.ts?vue&type=script&lang=ts&"
export * from "./columnsMappingBase.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports